module.exports = __webpack_public_path__ + "img/catalog.510893ce.svg";